import { render, staticRenderFns } from "./TimelinePost.vue?vue&type=template&id=18480c43"
import script from "./TimelinePost.vue?vue&type=script&lang=js"
export * from "./TimelinePost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports